import { useSelector } from 'react-redux'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'

// Components
import { Format } from '../../../..'
import { Button, ButtonGroup } from '@homebotapp/hb-react-component-catalog'
import { Heading, ProConList, Pro, Info, Strong } from '../../../../shared/Gem/GemDetail'
import CTAHeading from '../../CTAHeading'
import FeeRange from '../../FeeRange'
import { Player } from '../../../../shared/Player'
import { InstantOfferButton } from '../../../../shared/AvmModule/InstantOffer/InstantOfferButton'
import { HOMEOWNER_DIGEST_PURCHASING_POWER_SELL_AND_POCKET_PANEL } from '../../../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'

// Selectors
import { selectSellHomeVideoId, selectSellHomeVideoType } from '../../../../../store/selectors/videos'
import { selectInstantOfferEnabled } from '../../../../../store/selectors/powerUps'
import { selectSellPocketAmount } from '../../../../../store/selectors/home/equity/sellPocket'

// Utils
import history from '../../../../../history'
import { OVERLAY_HELPERS } from '../../../../../constants/navigation'

// Styles
import styles from './SellPocketDetail.module.scss'
import useViewport from '../../../../../hooks/useViewport'

const MSG = defineMessages({
  verifySellingPrice: {
    id: 'Homeowner.purchasePower.sellPocketButton.cma',
    defaultMessage: 'Verify listing price'
  }
})

const SellPocket = () => {
  const { isMedium } = useViewport()
  const intl = useIntl()
  const instantOfferEnabled = useSelector(selectInstantOfferEnabled)
  const cashout = useSelector(selectSellPocketAmount)

  const videoId = useSelector(selectSellHomeVideoId)
  const videoType = useSelector(selectSellHomeVideoType)

  return (
    <div>
      <Heading>
        <FormattedMessage
          id='Homeowner.purchasePower.sellPocketHeading'
          defaultMessage='Are you ready to cash in on your equity? You could sell your home and pocket around {cashout}.'
          values={{
            cashout: (
              <Strong>
                <Format.Currency abbreviate value={cashout} />
              </Strong>
            )
          }}
        />
      </Heading>
      {videoType && videoId && <Player className={styles.video} videoType={videoType} videoId={videoId} />}
      <ProConList className={styles.proCon}>
        <Pro>
          <FormattedMessage
            id='Homeowner.purchasePower.sellPocketOne'
            defaultMessage='You may be exempt from capital gains taxes if you’ve owned and lived in the home for at least two years out of the last five'
          />
        </Pro>
        <Pro>
          <FormattedMessage
            id='Homeowner.purchasePower.sellPocketTwo'
            defaultMessage='Up to $250,000 in profit may be tax-free for unmarried individuals and up to $500,000 for married couples'
          />
        </Pro>
        <Pro>
          <FormattedMessage
            id='Homeowner.purchasePower.sellPocketThree'
            defaultMessage='You could also downsize into a cheaper home using a portion of your equity and save the rest'
          />
        </Pro>
        <Info>
          <FeeRange />
        </Info>
        <Info>
          <FormattedMessage
            id='Homeowner.purchasePower.sellPocketFour'
            defaultMessage='Always consult a professional tax advisor to understand implications for your specific situation'
          />
        </Info>
      </ProConList>

      <CTAHeading className={styles.cta}>
        <FormattedMessage id='Homeowner.purchasePower.ctaHeading' defaultMessage="So, what's next?" />
      </CTAHeading>

      <ButtonGroup
        gap='1'
        width='100%'
        display='flex'
        justifyContent='center'
        orientation={isMedium ? 'vertical' : 'horizontal'}
      >
        <Button
          onClick={() => {
            history.push(OVERLAY_HELPERS.tuneYourValue.buildPath())
          }}
          tracking={{
            guid: 'ny3PYPB7ztqNANEox1VLve',
            ui_context: HOMEOWNER_DIGEST_PURCHASING_POWER_SELL_AND_POCKET_PANEL,
            descriptor: MSG.verifySellingPrice.defaultMessage
          }}
        >
          {intl.formatMessage(MSG.verifySellingPrice)}
        </Button>

        {instantOfferEnabled && (
          <InstantOfferButton
            tracking={{
              guid: 'iUgpyGJZkZvcFNpCtFQS1b',
              ui_context: HOMEOWNER_DIGEST_PURCHASING_POWER_SELL_AND_POCKET_PANEL
            }}
          />
        )}
      </ButtonGroup>
    </div>
  )
}

export default SellPocket
